import React from 'react';

interface Props {
  onClick(): void;
}

const ErrorMessage: React.FC<Props> = ({ children, onClick }) => (
  <div
    className="fixed bottom-0 m-8 w-5/6 md:w-full max-w-sm bg-red Popup-Error"
    onClick={onClick}
  >
    <div className="relative">
      <div className="leading-tight flex flex-col space-y-2 text-white text-center">
        <div className="text-sm font-bold">Something went wrong</div>
        <div className="leading-snug text-sm">{children}</div>
      </div>
      <svg
        className="fill-current text-white absolute top-0 right-0 cursor-pointer"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
      </svg>
    </div>
  </div>
);

export default ErrorMessage;
